<script setup lang="ts">
import InputField from '../../../../components/Fields/InputField.vue'
import StackLayout from '../../../../components/Layouts/StackLayout.vue'
import TypographyItem from '../../../../components/Typography/TypographyItem.vue'

type Props = {
    name?: string
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: string): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout direction="column" :gap="8" class="confirm-device-name">
        <TypographyItem :label="`${$t('device.actions.deleteDeviceNameConfirm')} :`" />
        <InputField
            :modelValue="name"
            :label="$t('device.actions.deleteDeviceName')"
            @change="$emit('change', $event)" />
    </StackLayout>
</template>

<style scoped lang="scss">
.confirm-device-name {
    margin-top: 16px;
}
</style>
